import React, { useEffect, useState } from "react";
import { Form, Button, Modal, Col, Row } from "antd";
import { vsmNotify } from "../../../../config/messages/common";
import useStore from "../../../../store";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import InputComponent from "../../../../component/InputComponent";
import { vsmProfile } from "./Validation";
import { debounce } from "@syncfusion/ej2-base";

const UserNameComponent = observer((props) => {
    const [form] = Form.useForm();
    const {
        AUTH: { editAvtarValues, user, updateUser },
        UserSettingStore,
    } = useStore();
    const [saving, setSaving] = useState();
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        if (props.visible && editAvtarValues) {
            form.setFieldsValue({
                name: editAvtarValues?.username
            })
        }
    }, [editAvtarValues, form, props])


    // check for valid form values then accordingly make save button disable / enable
    const handleChange = debounce(() => {
        form
            .validateFields()
            .then((d) => {
                setDisabled(false);
            })
            .catch((d) => {
                setDisabled(true);
            });
    }, 500);

    // Handle submit and call function to save new record
    const handleSubmit = (data) => {
        setSaving(true);
        let user_id = user.id;
        data.user_id = user_id;
        delete data.name;
        let currentUsername = data.username
        UserSettingStore.changeUserName(data)
            .then((data) => {
                close();
                updateUser("username",currentUsername)
                vsmNotify.success({
                    message: data.STATUS.NOTIFICATION[0],
                });
            })
            .catch((e) => {
                if (e.errors) {
                    form.setFields(e.errors);
                }
            })
            .finally(() => setSaving(false));
    };

    // reset form and close add form
    const close = () => {
        props.close();
        form.resetFields();
        setDisabled(true);
    };

    return (
        <Modal
            className="addModal"
            centered
            title="Change Username"
            width={534}
            open={props.visible}
            closeIcon={<FontAwesomeIcon icon={faTimes} />}
            onCancel={close}
            cancelButtonProps={{ style: { display: "none" } }}
            okButtonProps={{ style: { display: "none" } }}
            footer={[
                <Button
                    key="2"
                    htmlType="button"
                    className="cancelBtn mr-35"
                    onClick={close}
                >
                    Cancel
                </Button>,
                <Button
                    key="1"
                    disabled={disabled}
                    form="changeUserNameForm"
                    loading={saving}
                    htmlType="submit"
                    type="primary"
                >
                    Save
                </Button>,
            ]}
        >
            <Form
                form={form}
                id={"changeUserNameForm"}
                onFinish={handleSubmit}
                labelCol={{ span: 24 }}
                onChange={handleChange}
            >
                <Row>
                    <Col xs={{ span: 24 }}>
                        <InputComponent
                            type="text"
                            required
                            disabled
                            label="Current Username"
                            placeholder="Current Username"
                            name="name"
                        />
                    </Col>
                    <Col xs={{ span: 24 }}>
                        <InputComponent
                            type="text"
                            required
                            label="Username"
                            placeholder="Username"
                            name="username"
                            rules={vsmProfile.validation.username}
                        />
                    </Col>
                    <Col xs={{ span: 24 }}>
                        <InputComponent
                            required
                            label="Current Password"
                            type="password"
                            placeholder="Current Password"
                            name="password"
                            onChange={handleChange}
                            rules={vsmProfile.validation.password}
                        />
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
});

export default UserNameComponent;
